import commonPostTypeConfig from '../../common/postTypes/softSkill'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'softSkill',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
